export const selectDateString = 'Select Date'
export const selectDateList: Array<string> = [
  'Today',
  'Yesterday',
  'This Week',
  'Last Week',
  'Last Month',
  'Current Month',
  'Custom',
]
export const vpnlocationString = '/employeevpnattendance'

export const initialPageSize = 20

export const searchInputConstant = 'lead.staging'
